import { DeviceItem, GetDevicesOfProjectResponse } from 'src/model/api/v2/data-contracts';

export function reconstructDeviceTree(
    original: GetDevicesOfProjectResponse['categories'],
    filtered: DeviceItem[]
): GetDevicesOfProjectResponse['categories'] {
    if (original == null) {
        return [];
    }

    const filteredIds = new Set(filtered.map(d => d.id));
    const filteredMap = new Map(filtered.map(d => [d.id, structuredClone(d)]));
    return original
        .map(category => {
            const newSubcategories = category.subcategories
                .map(subcategory => {
                    const newDevices = subcategory.devices
                        .filter(d => filteredIds.has(d.id))
                        .map(d => filteredMap.get(d.id));
                    if (newDevices.length === 0) {
                        return null;
                    }
                    const cloned = structuredClone(subcategory);
                    cloned.devices = newDevices;
                    return cloned;
                })
                .filter(Boolean) as typeof category.subcategories;

            if (newSubcategories.length === 0) {
                return null;
            }
            return {
                ...structuredClone(category),
                subcategories: newSubcategories
            };
        })
        .filter(Boolean) as GetDevicesOfProjectResponse['categories'];
}

export function flattenDevices(data: GetDevicesOfProjectResponse['categories']): DeviceItem[] {
    if (data == null) {
        return [];
    }
    return data.flatMap(category =>
        category.subcategories.flatMap(subcategory => subcategory.devices)
    );
}

export function filterDevices(filterText: string, devices: DeviceItem[]) {
    if (filterText === '') {
        return devices;
    }
    const lowerFilter = filterText.toLowerCase();
    return devices.filter(device => device.text.toLowerCase().includes(lowerFilter));
}